import { StyledGutter } from './styled';

export const Gutter = StyledGutter;
